import * as React from "react";
import { addMonths, addYears, isAfter } from "date-fns";
import { useFormContext } from "react-hook-form";
import { DatePicker } from "components";
import { LicensePeriodEnum } from "requests";
import { FormValues } from "../../duck";

const StartDate: React.FC = () => {
  const { setValue, getValues } = useFormContext<FormValues>();

  return (
    <DatePicker
      name="startDate"
      label="Start Date"
      placeholderText="Start Date"
      minDate={new Date()}
      onChange={newDate => {
        setValue("startDate", newDate, { shouldValidate: true });
        const { expirationDate } = getValues();
        if (expirationDate && newDate && isAfter(newDate, expirationDate)) {
          setValue("expirationDate", null, { shouldValidate: true });
        }

        const { licensePeriod } = getValues();
        if (licensePeriod && newDate) {
          setValue(
            "expirationDate",
            licensePeriod === LicensePeriodEnum.Monthly
              ? addMonths(newDate, 1)
              : addYears(newDate, 1),
            { shouldValidate: true }
          );
        }
      }}
    />
  );
};

export default StartDate;
